import Multiselect from "multiselect-react-dropdown";
import { useGetMealschoiceQuery } from "../../../store/api/meals";
import React, { useState, useEffect } from "react";
import { useLocation ,useNavigate} from "react-router-dom";
import {useUpdateAssignedMealMutation } from '../../../store/api/meals'

function Editmeal() {
  const location = useLocation();
  const navigate = useNavigate();
  const [updateMeal] = useUpdateAssignedMealMutation ()
  const { data: choiceData, isLoading } = useGetMealschoiceQuery();
  const mealsDataoption = location.state?.data.meals || [];
  const [selectedMeals, setSelectedMeals] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mealUnits, setMealUnits] = useState({});
  const [mealQuantities, setMealQuantities] = useState({});
  const [feedback, setFeedback] = useState(null);
  const memberData = location.state?.data


  useEffect(() => {
    const initialSelectedMeals = {};
    const initialMealUnits = {};
    const initialMealQuantities = {};

    
    mealsDataoption.forEach(meal => {
      initialSelectedMeals[meal.name] = meal.food_items.map(item => ({
        id: item.id,
        name: item.name
      }));

      initialMealUnits[meal.name] = {};
      initialMealQuantities[meal.name] = {};

      meal.food_items.forEach(item => {
        initialMealUnits[meal.name][item.name] = item.unit || "gram";
        initialMealQuantities[meal.name][item.name] = item.quantity || 1;
      });
    });

    setSelectedMeals(initialSelectedMeals);
    setMealUnits(initialMealUnits);
    setMealQuantities(initialMealQuantities);
  }, [mealsDataoption]);

  const handleSelect = (selectedList, mealKey) => {
    setSelectedMeals(prev => ({
      ...prev,
      [mealKey]: selectedList
    }));
  };

  const handleUnitChange = (mealKey, itemName, event) => {
    const { value } = event.target;
    setMealUnits(prev => ({
      ...prev,
      [mealKey]: { ...prev[mealKey], [itemName]: value }
    }));
  };

  const handleQuantityChange = (mealKey, itemName, event) => {
    const { value } = event.target;
    setMealQuantities(prev => ({
      ...prev,
      [mealKey]: { ...prev[mealKey], [itemName]: value }
    }));
  };

  const handleSubmit = event => {
    event.preventDefault();

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const dataTosubmit = async () => {
    const formattedData = {
      member: memberData.member,  
      meals: Object.entries(selectedMeals).map(([mealName, foodItems]) => ({
        name: mealName,
        food_items: foodItems.map(item => ({
          id: item.id,
          name: item.name,
          unit: mealUnits[mealName]?.[item.name] || "gram",
          quantity: mealQuantities[mealName]?.[item.name] || 1
        }))
      }))
    };
    try {
      const response = await updateMeal(formattedData).unwrap();
      if (response.status ===200) {
        setTimeout(() => {
        setFeedback({ type: "success", message: "Data submitted successfully!" });
         navigate("/asigned-meal-list")
        }, 2000);
      }
      ;
      
     

    } catch (error) {
     
      setFeedback({ type: "error", message: "Failed to update meal." });
    }
  
    closeModal();
  };
  

 
  
  return (
    <div className="pb-4 pt-3 px-5">
      <div className="flex mb-4">
        <div className="w-[100%] rounded-sm mx-2 shadow-xl bg-white">
          <div>
            <div className="ml-4">
              <h2 className="mt-3 text-lg font-medium mb-4 mx-2">Edit Meal</h2>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col text-xs px-6 mb-3 mt-4 font-bold">
                {Object.keys(selectedMeals).map(mealKey => (
                  <div className="mt-5" key={mealKey}>
                    <label className="mt-5">{mealKey}</label>
                    <Multiselect
                      className="mt-2 text-sm w-full"
                      options={mealsDataoption.find(meal => meal.name === mealKey)?.food_items.map(item => ({
                        id: item.id,
                        name: item.name
                      })) || []}
                      selectedValues={selectedMeals[mealKey] || []}
                      onSelect={selectedList => handleSelect(selectedList, mealKey)}
                      onRemove={selectedList => handleSelect(selectedList, mealKey)}
                      displayValue="name"
                    />
                  </div>
                ))}
                <div className="mt-3 mb-3">
                  <button type="submit" className="px-4 py-2 bg-secondary text-white font-semibold rounded-lg">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[80%] max-w-3xl">
            <h2 className="text-xl font-semibold mb-4">Selected Meals</h2>
            {feedback?.type && (
              <div className={`mt-3 mx-3 rounded-lg px-4 py-3 text-md font-medium border ${
                feedback.type === "success" ? "bg-green-100 text-green-700 border-green-300" : "bg-red-100 text-red-700 border-red-300"
              }`} role="alert">
                {feedback.message}
              </div>
            )}
            <div className="max-h-[60vh] overflow-y-auto border-t border-b border-gray-300">
              <table className="w-full border border-gray-300 mt-4">
                <thead className="sticky top-0 bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 p-2">Meal</th>
                    <th className="border border-gray-300 p-2">Food Item</th>
                    <th className="border border-gray-300 p-2">Unit</th>
                    <th className="border border-gray-300 p-2">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(selectedMeals).map(([mealKey, meals]) => (
                    meals.map((meal, idx) => (
                      <tr key={`${mealKey}-${idx}`} className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                        {idx === 0 && (
                          <td className="border px-5 border-gray-300 p-2" rowSpan={meals.length}>
                            {mealKey}
                          </td>
                        )}
                        <td className="border px-5 border-gray-300 p-2">{meal.name}</td>
                        <td className="border px-5 border-gray-300 p-2">
                          <select value={mealUnits[mealKey]?.[meal.name] || ''} onChange={(e) => handleUnitChange(mealKey, meal.name, e)} className="p-2 border rounded">
                            <option value="">Select Unit</option>
                            <option value="gram">Gram</option>
                            <option value="protein">Protein</option>
                            <option value="ounce">Ounce</option>
                            <option value="ltr">Litre</option>
                          </select>
                        </td>
                        <td className="border px-5 border-gray-300 p-2">
                          <input type="number" value={mealQuantities[mealKey]?.[meal.name] || ''} onChange={(e) => handleQuantityChange(mealKey, meal.name, e)} className="p-2 border rounded w-20" placeholder="Quantity" />
                        </td>
                      </tr>
                    ))
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-4 text-right">
              <button onClick={closeModal} className="px-4 py-2 bg-gray-300 text-black font-semibold rounded-lg mr-3">
                Close
              </button>
              <button onClick={dataTosubmit} className="px-4 py-2 bg-secondary text-white font-semibold rounded-lg">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Editmeal;
